import AutoComplete from "./AutoComplete";
import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import { calculateAllocation } from "../../calculations";
import { useSelector } from "react-redux";
import config from "../../config";
import Toast from "../Common/Toast";
import { BiSolidUpArrow, BiSolidDownArrow } from "react-icons/bi";

const ShowStocksTabPage = ({ toggleStocksModal, updateRecipe, stocks, setStocks, currentBasketId, currentCompanyId, basketName }) => {

    const [inputs, setInputs] = useState({
        stockId: "",
        stockName: "",
        allocationPercent: 0,
        newAllocation: 0,
        comment: "",
        isFixed: true
    });

    const [editOn, setEditOn] = useState(false)
    const [disablePublish, setDisablePublish] = useState(false)
    const [allocationEditOn, setAllocationEditOn] = useState(false)
    const [index, setIndex] = useState(null)
    const [lists, setLists] = useState(stocks)
    const [totalAllocation, setTotalAllocation] = useState(0);
    const [addOnDisabled, setAddOnDisabled] = useState(false)
    const [updateOnDisabled, setUpdateOnDisabled] = useState(false)
    const [saveOnDisabled, setSaveOnDisabled] = useState(false)
    const [pageErroCount, setPageErrorCount] = useState(0);


    const [basketId, setBasketId] = useState(currentBasketId)
    //const [companyId, setCompanyId] = useState(currentCompanyId)
    const companyId = useSelector((state) => state.user.companyId);

    const [stocksList, setStocksList] = useState([]);
    //if (stocks.length>0) setStocksList(stocks)

    const [toast, setToast] = useState({ show: false, message: "", type: "info" });

    const [errStock, setErrStock] = useState("")
    const [errquantity, setErrQuantity] = useState("")
    const [errremark, setErrRemark] = useState("")
    const [errisfixed, setErrIsfixed] = useState("")
    const [errWorkflow, setErrWorkflow] = useState("")

    const showToast = (message, type = "info") => {
        setToast({ show: true, message, type });
    };

    const isNewlyAddedStock = (row) => {
        return row?.basketStockId === "" || row?.basketStockId === null || row?.basketStockId === undefined;
    };

    const calculateTotalAllocationFromRows = (rows = []) => {
        const total = rows.reduce((sum, row) => {
            const hasNewAllocation = row?.newAllocation !== null && row?.newAllocation !== undefined && String(row.newAllocation).trim() !== "";
            const value = hasNewAllocation ? Number(row.newAllocation) : Number(row?.allocationPercent || 0);
            return sum + (Number.isFinite(value) ? value : 0);
        }, 0);
        return total.toFixed(2);
    };

    const handleInlineRowChange = (rowIndex, field, value) => {
        setLists((prev) => {
            const source = Array.isArray(prev?.data) ? prev.data : prev;
            const nextRows = [...(Array.isArray(source) ? source : [])];
            if (!nextRows[rowIndex]) return prev;

            nextRows[rowIndex] = {
                ...nextRows[rowIndex],
                [field]: value,
                isModified: true
            };

            const nextTotal = calculateTotalAllocationFromRows(nextRows);
            setTotalAllocation(nextTotal);
            setSaveOnDisabled(false);
            setDisablePublish(true);

            return Array.isArray(prev?.data) ? { ...prev, data: nextRows } : nextRows;
        });
    };

    const renderAllocationTrend = (row) => {
        const rawNewAllocation = row?.newAllocation;
        const hasNewAllocation = rawNewAllocation !== null && rawNewAllocation !== undefined && String(rawNewAllocation).trim() !== "";

        if (!hasNewAllocation) {
            return null;
        }

        const allocationValue = Number(row?.allocationPercent || 0);
        const newAllocationValue = Number(rawNewAllocation);

        if (!Number.isFinite(allocationValue) || !Number.isFinite(newAllocationValue)) {
            return null;
        }

        if (newAllocationValue > allocationValue) {
            return <BiSolidUpArrow className="text-green-600" title="Increased" />;
        }

        if (newAllocationValue < allocationValue) {
            return <BiSolidDownArrow className="text-red-600" title="Decreased" />;
        }

        return <span className="text-black font-semibold" title="No change">-</span>;
    };

    const reloadBasketStocks = async () => {
        try {
            const resStocks = await axios.get(config.BL_API_URL + "/basketstock/v1/getbasketstockbyid", { params: { basketId: currentBasketId } });
            const refreshedRows = Array.isArray(resStocks?.data) ? resStocks.data : [];
            setLists(refreshedRows);
            setStocks(refreshedRows);
            setTotalAllocation(calculateTotalAllocationFromRows(refreshedRows));
            setSaveOnDisabled(true);
            return refreshedRows;
        } catch (error) {
            showToast("Failed to reload basket stocks.", "error");
            return [];
        }
    };

    useEffect(() => {
        setStocks(lists);
        updatePublishButton(lists);
    }, [lists, lists.data, stocks])
    const refLists = React.useRef(lists);
    const refBasketId = React.useRef(currentBasketId);
    const refCompanyId = React.useRef(currentCompanyId);
    
    // get Stocks list --
    useEffect(() => {
        const getStocksList = async (e) => {
            try {
                /**Stocks look up list */
                const res = await axios.get(config.BL_API_URL + "/stock/v1");
                if (res && res.data)
                    setStocksList(res.data)
                else
                    showToast("Backend message while fetching stock lookup.", "warning");

            } catch (message) {

                if (message.response)
                    showToast(message.response.data, "error");
                else
                    showToast("Server error...", "error");
            }
        }

        getStocksList();
        setTotalAllocation(parseFloat(calculateAllocation(lists, inputs)).toFixed(2));
        setActionButtonState();
        setSaveOnDisabled(true);
        //setUpdateOnDisabled(false);
    }, [])

    const setActionButtonState = () => {
        if (!editOn) {
            if (inputs.stockName.length < 0 || inputs.allocationPercent <= 0 || inputs.comment.length <= 0) {
                setAddOnDisabled(true);
            }
            else {
                setAddOnDisabled(false);
            }
        } else {
            setPageErrorCount(0);
            if (inputs.newAllocation == null || inputs.comment.length <= 0) {
                setUpdateOnDisabled(true);
            }
            else if (inputs.newAllocation > 0)
                setUpdateOnDisabled(false);
        }
    }

    const handleChange = (e) => {

        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        setInputs((prev) => ({ ...prev, [e.target.name]: value }));

        if (e.target.name == "allocationPercent" || e.target.name == "newAllocation") {

            setTotalAllocation(parseFloat(calculateAllocation(lists, inputs)).toFixed(2));
        }

        setActionButtonState();
    };

    function updatePublishButton(lists) {
        setErrWorkflow("");
        let unSavedBasketStock = false;
        let publishButton = document.getElementById("publishButton");
        if ((lists.data == null || lists.data.length <= 0) && lists == null) {
            setDisablePublish(true);
            return;
        }
        if ((lists == null || lists.length <= 0)) {
            setDisablePublish(true);
            return;
        }
        lists.forEach(element => {//if basket stock is not published
            if ((element.basketStockId == "" || element.basketStockId == null) && !saveOnDisabled) {
                setErrWorkflow("Basket needs to be saved first to publish the basket orders!")
                unSavedBasketStock = true;
                return;
            }
        });

        if (!unSavedBasketStock)
            setDisablePublish(false);
        else
            setDisablePublish(true);

    }

    const handleSave = async (e) => {
        e.preventDefault();
        setErrWorkflow("")
        if ((!editOn && !addOnDisabled)) {
            handleAdd(e);
        }
        if ((editOn && !updateOnDisabled)) {
            handleUpdate();
        }

        if (pageErroCount > 0) {
            return;
        }
        const updateResponse = await updateRecipe();
        const responseStatus = String(updateResponse?.status || "").trim().toLowerCase();
        const responseMessages = Array.isArray(updateResponse?.messages)
            ? updateResponse.messages.filter((msg) => typeof msg === "string" && msg.trim() !== "")
            : [];

        if (responseStatus === "error") {
            const errorMessage = responseMessages.length > 0
                ? responseMessages.join(", ")
                : "Failed to save basket stocks.";
            showToast(errorMessage, "error");
            return;
        }

        setStocks(stocks)
        if (stocks != null && stocks.length > 0) {
            stocks.forEach(element => {
                if (element.isModified != null && element.isModified) {
                    element.isModified = false;
                }
            });
        }
        setDisablePublish(false);
        setSaveOnDisabled(true);
        setAddOnDisabled(true);
        setUpdateOnDisabled(true);
        await reloadBasketStocks();
        const successMessage = responseMessages.length > 0
            ? responseMessages.join(", ")
            : "Saved successfully!";
        showToast(successMessage, "success")
    }

    const handlePublishButton = async (e) => {
        try {
            if (pageErroCount > 0) {
                return;
            }
            //const res = await axios.get(config.BL_API_URL+"/BasketRebalance/v1", { params: {basketId, companyId} });
            //console.log("BasketID " + currentBasketId);
            //console.log("CompanyID " + currentCompanyId);            
            let basketId = currentBasketId;
            let companyId;
            if (companyId == null) {
                companyId = currentCompanyId;
            }

            const res = await axios.get(config.BL_API_URL + "/BasketRebalance/v1", { params: { basketId, companyId } });
            if (res.status != 200) {
                showToast("executed basket orders with with errors", "warning");
            }
            else
                showToast("Basket published successfully", "success");
        }
        catch (message) {

            if (message.response)
                showToast(message.response.data, "error");
            else
                showToast("Server error while publishing basket", "error");
        }

    }

    const handleAdd = async (e) => {
        e.preventDefault();

        setErrWorkflow("")
        setErrStock("")
        setErrQuantity("")
        setErrRemark("")
        setErrIsfixed("")
        var errCount = 0;

        if (inputs.stockName.length < 2 || inputs.stockName.length > 40) {
            setErrStock("* please select stock name from the list! ")
            errCount++;
        }

        if (inputs.comment.length < 10 || inputs.comment.length > 400) {
            setErrRemark("* remarks must be 10 to 400 in length! ")
            errCount++;
        }

        if (!editOn) {
            if (inputs.allocationPercent === null || inputs.allocationPercent < 0 || inputs.allocationPercent > 100) {
                setErrQuantity("* minimum allocation percent 0.1 and maximum 100 across all stocks")
                errCount++;
            }
        }

        if (editOn) {
            if (inputs.newAllocation === null || inputs.newAllocation < 0 || inputs.newAllocation > 100) {
                setErrQuantity("* minimum allocation percent 0.1 and maximum 100 across all stocks")
                errCount++;
            }
        }

        //check if stock already presesent in list

        setPageErrorCount(errCount);

        if (errCount === 0) {
            if (totalAllocation > 100) {
                setErrRemark("* total allocation can't exceed 100%");
                return;
            }

            var newObj;
            inputs.isModified = true;
            if (lists.data != null) {
                newObj = [...lists.data, inputs];
            }
            else
                newObj = [...lists, inputs]

            setLists(newObj)
            setStocks(newObj)
            setInputs({
                basketStockId: "",
                stockId: "",
                stockName: "",
                allocationPercent: 0,
                newAllocation: 0,
                comment: "",
                isFixed: false,
                isModified: false
            })
            setSaveOnDisabled(false);
            setAddOnDisabled(true);
            if (document.getElementById("searchStockName") != null) {
                document.getElementById("searchStockName").focus()
            }

        }
    };

    // move list up
    const moveUp = (index) => {
        var newlist = lists
        var tmpObj = lists[index - 1]
        newlist[index - 1] = lists[index]
        newlist[index] = tmpObj
        setLists([...newlist])
        setStocks([...newlist])
        console.log(newlist)
    }

    const handleClose = () => {
        //handleSave();
        if (!saveOnDisabled) {
            if (window.confirm("Are you sure you want to close without saving the changes?")) {
                toggleStocksModal();
            }
        }
        else {
            toggleStocksModal();
        }

    }

    // move list down
    const moveDown = (index) => {
        var newlist = lists
        var tmpObj = lists[index + 1]
        newlist[index + 1] = lists[index]
        newlist[index] = tmpObj
        setLists([...newlist])
        setStocks([...newlist])
        console.log(newlist)
    }

    const editMode = (index) => {
        /*         if(updateOnDisabled == true || addOnDisabled == false){
                    setErrWorkflow("Please save or update the changes before editing another stock!");
                    return;
                } */
        setIndex(index)
        setEditOn(true)
        /* inputs.allocationPercent = 0;
        inputs.newAllocation = 0; */
        setTotalAllocation(parseFloat(calculateAllocation(lists, inputs)).toFixed(2));
        isNewStock(lists[index].stockName)

        //console.log(lists[index])
        setInputs({
            basketStockId: lists[index].basketStockId,
            stockId: lists[index].stockId,
            stockName: lists[index].stockName,
            allocationPercent: lists[index].allocationPercent,
            newAllocation: lists[index].allocationPercent,
            comment: lists[index].comment,
            isFixed: lists[index].isFixed
        });
        if (lists[index].isModified) {

            setInputs({
                basketStockId: lists[index].basketStockId,
                stockId: lists[index].stockId,
                stockName: lists[index].stockName,
                allocationPercent: lists[index].allocationPercent,
                newAllocation: lists[index].newAllocation,
                comment: lists[index].comment,
                isFixed: lists[index].isFixed
            });
        }

    }
    //lists[index].newAllocation == null  ? lists[index].allocationPercent : lists[index].newAllocation
    //handleAllocation(lists[index].newAllocation, lists[index].allocationPercent, lists[index].stockName)
    const handleAllocation = (newAllocation, allocation, stockName) => {
        if (newAllocation != null)
            return newAllocation;

        lists.forEach(element => {
            if (element.stockName === stockName) {
                return "";
            }
        });
        //return allocation;
    }

    function isNewStock(stockName) {
        refLists.current.forEach(element => {
            if (element.stockName === stockName && element.basketStockId != null) {
                setAllocationEditOn(true);
                return;
            }
        });
    }




    // update stocks after edit
    const handleUpdate = () => {
        setErrStock("")
        setErrQuantity("")
        setErrRemark("")
        setErrIsfixed("")
        var errCount = 0;

        if (inputs.stockName.length < 3 || inputs.stockName.length > 40) {
            setErrStock("* stockName must be 3 to 40 in length! ")
            errCount++;
        }

        if (inputs.comment != null && (inputs.comment.length < 10 || inputs.comment.length > 400)) {
            setErrRemark("* remarks must be 10 to 400 in length! ")
            errCount++;
        }

        if (inputs.allocationPercent === null || inputs.allocationPercent < 0 || inputs.allocationPercent > 100) {
            setErrQuantity("* minimum allocation percent 0.1 and maximum 100 across all stocks")
            errCount++;
        }

        if (inputs.newAllocation === null || inputs.newAllocation < 0 || inputs.newAllocation > 100) {
            setErrQuantity("* minimum allocation percent 0.1 and maximum 100 across all stocks")
            errCount++;
        }

        setPageErrorCount(errCount);

        if (errCount === 0) {
            if (totalAllocation > 100) {
                setErrRemark("* total allocation can't exceed 100%");
                return;
            }
            var newObj;
            if (lists.data == null)
                newObj = [...lists]
            else
                newObj = [...lists.data]

            inputs.isModified = true;
            newObj[index] = inputs
            setLists([...newObj])
            //console.log(newObj)
            setStocks([...newObj])
            setEditOn(false)
            setAllocationEditOn(false)
            setInputs({
                stockId: "",
                stockName: "",
                allocationPercent: "",
                newAllocation: "",
                comment: "",
                isFixed: false,
                isVisible: true,
                isModified: false
            });
            setIndex(null)
            setDisablePublish(true);
            setSaveOnDisabled(false);
        }

    }

    const handleCancelAddOrUpdate = () => {
        setEditOn(false)
        setInputs({
            stockId: "",
            stockName: "",
            allocationPercent: "",
            newAllocation: "",
            comment: "",
            isFixed: false,
            isVisible: true,
            isModified: false
        });
        setIndex(null)
        setDisablePublish(true);
        setSaveOnDisabled(true);
        setAddOnDisabled(true)
    }

    return (

        <div className="w-full">
            <Toast
                show={toast.show}
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ show: false, message: "", type: "info" })}
            />
            <div className="relative p-1 w-full">

                <div className="border mx-auto relative bg-formbackground rounded-lg shadow-md ">

                    <div className=" flex items-center justify-between p-1 md:p-1 border-b rounded-t ">
                        <h3 className="text-l font-semibold text-gray-900 ">
                            Rebalance Basket {basketName} Stocks
                        </h3>
                        {/*  {editOn &&
                            <h3 className="text-xl font-semibold text-gray-900 ">
                                Edit Stock
                            </h3>
                        }
                        {!editOn &&
                            <h3 className="text-xl font-semibold text-gray-900 ">
                               < Add >Stock
                            </h3>                
                        }
                        <br></br> */}
                        {allocationEditOn &&
                            <h3 className="text-l font-semibold text-gray-900 ">
                            </h3>
                        }
                        {!allocationEditOn &&
                            <h3 className="text-l font-semibold text-gray-900 ">
                            </h3>
                        }

                        <button onClick={e => handleClose()} type="button" className="end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center ">
                            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                            </svg>
                            <span className="sr-only">Close modal</span>
                        </button>
                    </div>

                    <div className="p-1 md:p-1">
                        <div className="space-y-1">
                            <div className="flex space-x-4 relative z-30">
                                <div className="width-1/2">
                                    <label htmlFor="af-account-full-name" className="inline-block text-sm text-gray-800 mt-2.5 ">
                                        <span className={`${errStock ? "text-red-500 " : ""}`}>Stock </span>
                                    </label>
                                </div>
                                <div className="width-2 relative z-40">
                                    <AutoComplete
                                        setInputs={setInputs}
                                        data={stocksList}
                                        inputs={inputs}
                                        editOn={editOn}
                                    />
                                </div>
                                <div className="width-1/2">
                                    <label htmlFor="af-account-full-name" className="inline-block text-sm text-gray-800 mt-1 ">
                                        <span className={`${errquantity ? "text-red-500 " : ""}`}>Allocation%</span>
                                    </label>
                                </div>
                                <div className="width-1/2">
                                    {!editOn &&
                                        <input
                                            onKeyUp={handleChange}
                                            onChange={handleChange} step="0.1" min={0.1} max={100}
                                            onBlur={(e) => {

                                                e.target.value = parseFloat(e.target.value).toFixed(2);
                                            }}
                                            type="number" name="allocationPercent" id="allocationPercent" placeholder="" value={inputs.allocationPercent}
                                            className="py-2 px-3 pe-2 block w-full border-gray-200 shadow-sm text-sm rounded-lg focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none " />
                                    }
                                    {editOn &&
                                        <input
                                            onKeyUp={handleChange}
                                            onChange={handleChange} min={0.1} max={100}
                                            onBlur={(e) => {

                                                e.target.value = parseFloat(e.target.value).toFixed(2);
                                            }}
                                            type="number" name="newAllocation" id="newAllocation" placeholder="" value={inputs.newAllocation}
                                            disabled={isNewlyAddedStock(inputs)}
                                            className="py-2 px-3 pe-2 block w-full border-gray-200 shadow-sm text-sm rounded-lg focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none " />

                                    }
                                </div>
                                <div className="flex-1/2">
                                    <label htmlFor="af-account-full-name" className="inline-block text-sm text-gray-800 mt-1 ">
                                        <span className={`${errremark ? "text-red-500 " : ""}`}>Remark </span>
                                    </label>
                                </div>
                                <div className="width-2">
                                    <textarea
                                        onChange={handleChange} maxLength={100}
                                        name="comment" id="comment" placeholder="" rows="1" value={inputs.comment}
                                        className="py-2 px-3 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none " ></textarea>
                                </div>
                                <div className="width-1/2">
                                    <label htmlFor="af-account-full-name" className="inline-block text-sm text-gray-800 mt-1 ">
                                        <span className={`${errisfixed ? "text-red-500 " : ""}`}>No Selling</span>
                                    </label>
                                </div>
                                <div className="width-1/2">
                                    <input
                                        onChange={handleChange}
                                        name="isFixed" id="isFixed" type="checkbox" checked={inputs.isFixed} defaultValue={false}
                                        className="mt-1 p-2 w-6 h-6 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 " />
                                </div>
                                <div className="width-1/2">
                                    {editOn &&
                                        <button disabled={updateOnDisabled} onClick={handleUpdate} className="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3.5 py-2.5 text-center disabled:opacity-20">Update</button>
                                    }

                                    {!editOn &&
                                        <button disabled={addOnDisabled} onClick={handleAdd} className="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3.5 py-2.5 text-center disabled:opacity-15 ">Add</button>
                                    }
                                </div>
                                <div className="width-1/2">
                                    <button onClick={handleCancelAddOrUpdate} className="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3.5 py-2.5 text-center disabled:opacity-20">Cancel</button>

                                </div>
                                <div className="width-1/2">
                                    <button disabled={saveOnDisabled} onClick={handleSave} className=" text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3.5 py-2.5 text-center disabled:opacity-20 ">Save</button>
                                </div>
                                <div className="width-1/2">
                                    <button id="publishButton" disabled={disablePublish} onClick={handlePublishButton} className=" text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3.5 py-2.5 text-center disabled:opacity-20 ">Publish</button>
                                </div>
                                {/* Add more columns here */}
                                {/* Add more columns here */}
                            </div>



                            <div className="overflow-hidden">
                                <div className="flex flex-col">
                                    <div className="-m-1.5 overflow-x-auto">
                                        <div className="p-1.5 min-w-full inline-block align-middle">
                                            {/* <div className="p-1.5 min-w-full inline-block align-right"> */}
                                            {/* <div className="flex space-x-0 mb-1 "> */}
                                            {/* <div className="flex-1 w-2 text-nowrap">
                                                    <label>Total Allocation: </label><label className={totalAllocation > 100 ? 'bg-red-500' : 'bg-yellow-500'} id="totalAllocation">{totalAllocation}<label > %</label></label>
                                                </div> */}
                                            {/* <div className="flex-2 justify-end">
                                                    <div className="flex space-x-0 ">
                                                        <div className="flex space-x-0 ">
                                                            <div className="flex-1  px-2">

                                                                <button id="Export" onClick={handleExportButton} className=" text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-2 py-2.5 text-center disabled:opacity-20 h-8">Export</button>
                                                            </div>
                                                            <div className="flex-1  px-2">

                                                                <button id="publishButton" disabled={disablePublish} onClick={handlePublishButton} className=" text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-2 py-2.5 text-center disabled:opacity-20 h-8">Publish</button>
                                                            </div>

                                                            <div className="flex-1 ">
                                                                <button disabled={saveOnDisabled} onClick={handleSave} className=" text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-2 py-2.5 text-center disabled:opacity-20 h-8 mr-28">Save</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            {/* </div> */}
                                            <div className="border rounded-lg divide-y divide-gray-200 overflow-hidden">
                                                <div className="max-h-[380px] overflow-y-auto">
                                                <table className="min-w-full table-fixed divide-y divide-gray-300 text-xs">
                                                    <colgroup>
                                                        <col className="w-[6%]" />
                                                        <col className="w-[34%]" />
                                                        <col className="w-[15%]" />
                                                        <col className="w-[15%]" />
                                                        <col className="w-[20%]" />
                                                        <col className="w-[10%]" />
                                                    </colgroup>
                                                    <thead className="bg-gray-300 sticky top-0 z-10 shadow-sm" >
                                                        {/* <tr className="flex justify-between w-full">
                                                            {stockItems &&
                                                                stockItems.slice(0, 5).map((item, index) => (
                                                                    <th key={index} scope="col" className="px-6 py-2 text-start text-xs font-medium text-gray-500 uppercase">{item.name}</th>
                                                                ))}
                                                        </tr> */}
                                                        <tr>
                                                            <th scope="col" className="px-2 py-1.5 text-start text-[11px] font-bold text-gray-700 uppercase tracking-wide">#</th>
                                                            <th scope="col" className="px-2 py-1.5 text-start text-[11px] font-bold text-gray-700 uppercase tracking-wide">Scrip Name</th>
                                                            <th scope="col" className="px-2 py-1.5 text-start text-[11px] font-bold text-gray-700 uppercase tracking-wide">Allocation%</th>
                                                            <th scope="col" className="px-2 py-1.5 text-start text-[11px] font-bold text-gray-700 uppercase whitespace-nowrap tracking-wide">New Allocation%</th>
                                                            <th scope="col" className="px-2 py-1.5 text-start text-[11px] font-bold text-gray-700 uppercase tracking-wide">Remark</th>
                                                            <th scope="col" className="px-2 py-1.5 text-center text-[11px] font-bold whitespace-nowrap text-gray-700 uppercase tracking-wide">No Selling</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="divide-y divide-gray-200">
                                                        {lists && lists.length > 0 &&
                                                            lists.map((list, rowNumber) => (
                                                                <tr key={list.stockName} className={`hover:bg-gray-400 
                                                                    ${index === rowNumber ? 'bg-blue-200' : 'hover:bg-gray-400'} `}>
                                                                    <td className="px-2 py-1 text-start text-[11px] text-gray-800">{rowNumber + 1}</td>
                                                                    <td className="px-2 py-1 text-start whitespace-nowrap text-[11px] text-gray-800 uppercase truncate">{list.stockName}</td>
                                                                    <td className="px-2 py-1 text-start text-[11px] text-gray-800" data-id={list.stockName} id={list.stockName} >{list.allocationPercent}</td>
                                                                    <td className="px-2 py-1 text-start whitespace-nowrap text-[11px] text-gray-800">
                                                                        <div className="flex items-center gap-2">
                                                                            <span className="inline-flex items-center justify-center w-4">
                                                                                {renderAllocationTrend(list)}
                                                                            </span>
                                                                            <input
                                                                                type="number"
                                                                                min={0}
                                                                                max={100}
                                                                                step="0.1"
                                                                                value={list.newAllocation ?? ""}
                                                                                disabled={isNewlyAddedStock(list)}
                                                                                onChange={(e) => handleInlineRowChange(rowNumber, "newAllocation", e.target.value)}
                                                                                className="py-0.5 px-1.5 pe-1.5 block w-full border-gray-200 shadow-sm text-[11px] rounded-md focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none"
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    <td className="px-2 py-1 text-start whitespace-nowrap text-[11px] text-gray-800">
                                                                        <input
                                                                            type="text"
                                                                            maxLength={100}
                                                                            value={list.comment ?? ""}
                                                                            onChange={(e) => handleInlineRowChange(rowNumber, "comment", e.target.value)}
                                                                            className="py-0.5 px-1.5 pe-1.5 block w-full border-gray-200 shadow-sm text-[11px] rounded-md focus:border-blue-500 focus:ring-blue-500"
                                                                        />
                                                                    </td>
                                                                    <td className="px-2 py-1 text-center whitespace-nowrap text-[11px] text-gray-800">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={!!list.isFixed}
                                                                            onChange={(e) => handleInlineRowChange(rowNumber, "isFixed", e.target.checked)}
                                                                            className="w-3.5 h-3.5 border border-gray-300 rounded bg-gray-50"
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </table>
                                                </div>

                                            </div>
                                            <div className="flex space-x-0 mb-1 ">
                                                <div className="flex-1 w-2 text-nowrap ">
                                                    <p className="text-red-400 mt-2">
                                                        {errWorkflow}
                                                        {errStock}
                                                        {errquantity}
                                                        {errremark}
                                                    </p>

                                                </div>
                                                <div className="flex-1 w-2 text-nowrap ">
                                                    <label className="mt-2">Total : </label><label className={totalAllocation > 100 ? 'bg-red-500' : 'bg-yellow-500'} id="totalAllocation">{totalAllocation}<label > %</label></label>
                                                </div>
                                                <div className="flex-1 w-2 text-nowrap "></div>
                                            </div>
                                            {/* error show */}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

    export default ShowStocksTabPage